'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    angular.module('app.api').component('apiIndex', {
        require: { app: '^app' },
        template: '<div style="padding: 2em 2em;" translate-namespace="api"><div class="container"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label}}</a></li><li translate>.Api</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="fa fa-code" aria-hidden="true"></i> <a ui-sref="open-data-middleware" translate>.Open data middleware API</a></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="panel panel-default panel-dial"><div class="panel-body"><i class="fa fa-code" aria-hidden="true"></i> <a ui-sref="datasets" translate>.Datasets API</a></div></div></div></div></div></div>',
        controller: ApiIndexController,
        controllerAs: '$ctrl'
    });

    function ApiIndexController() {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {};
        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};
    }
})();